"use client";

import { UploadCloud } from "lucide-react";
import { useRef, useState } from "react";
import { cn } from "@/lib/utils";

export function Dropzone({
  accept,
  multiple = false,
  onFiles,
  hint,
  label = "Dosyaları buraya sürükleyin",
  className,
}: {
  /** input accept değeri, ör. "application/pdf" */
  accept: string;
  multiple?: boolean;
  onFiles: (files: File[]) => void;
  hint?: string;
  label?: string;
  className?: string;
}) {
  const [over, setOver] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  function accepts(file: File) {
    // accept listesini elle uygularız; sürükle-bırakta tarayıcı bunu yapmıyor
    return accept.split(",").some((rule) => {
      const r = rule.trim().toLowerCase();
      if (!r) return true;
      if (r.endsWith("/*")) return file.type.toLowerCase().startsWith(r.slice(0, -1));
      if (r.startsWith(".")) return file.name.toLowerCase().endsWith(r);
      return file.type.toLowerCase() === r;
    });
  }

  function handle(list: FileList | null) {
    if (!list) return;
    const files = Array.from(list).filter(accepts);
    if (files.length) onFiles(multiple ? files : files.slice(0, 1));
  }

  return (
    <div
      onDragOver={(e) => {
        e.preventDefault();
        setOver(true);
      }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => {
        e.preventDefault();
        setOver(false);
        handle(e.dataTransfer.files);
      }}
      onClick={() => inputRef.current?.click()}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          inputRef.current?.click();
        }
      }}
      role="button"
      tabIndex={0}
      className={cn(
        "flex cursor-pointer flex-col items-center justify-center rounded-2xl border-2 border-dashed px-6 py-14 text-center transition",
        over
          ? "border-brand bg-brand-soft"
          : "border-border bg-surface hover:border-brand/50 hover:bg-surface-muted",
        className,
      )}
    >
      <span className="mb-4 grid size-14 place-items-center rounded-2xl bg-brand-soft text-brand">
        <UploadCloud className="size-6" />
      </span>
      <p className="font-medium">{label}</p>
      <p className="mt-1 text-sm text-muted">
        veya <span className="text-brand underline underline-offset-2">bilgisayarından seç</span>
      </p>
      {hint && <p className="mt-3 text-xs text-muted">{hint}</p>}

      <input
        ref={inputRef}
        type="file"
        accept={accept}
        multiple={multiple}
        hidden
        onChange={(e) => {
          handle(e.target.files);
          e.target.value = ""; // aynı dosyayı tekrar seçebilmek için
        }}
      />
    </div>
  );
}
